var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('product-list',{attrs:{"products":_vm.products}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }